import { useSession } from '@side/next-auth/react';
import { useIdentity } from '$api-clients/hooks';

export function useAgentTeam() {
  const userId = useSession().data?.user?.id;
  const {
    data: teamMemberships,
    isLoading: teamMembershipsLoading,
    error: teamMembershipsError,
  } = useIdentity(
    '/users/{userId}/team-members',
    userId
      ? {
          params: { path: { userId } },
        }
      : null,
  );

  const sortedMemberships = [...(teamMemberships?.data ?? [])].sort((a, b) => {
    if (!a || !b) {
      return 0;
    }

    // if they have same legalName, sort by alias
    if (a.team.legalName === b.team.legalName && a.team.alias && b.team.alias) {
      return a.team.alias.localeCompare(b.team.alias);
    }
    return (a.team.legalName ?? '').localeCompare(b.team.legalName ?? '');
  });

  const firstTeamMembership = sortedMemberships?.length
    ? sortedMemberships[0]
    : null;

  const firstActiveAgentTeamMembership = sortedMemberships?.find(
    ({ roles, status }) => roles.includes('AGENT') && status === 'ACTIVE',
  );

  const teamMembershipToUse =
    firstActiveAgentTeamMembership ?? firstTeamMembership;

  const {
    data: team,
    isLoading: teamIsLoading,
    error: teamError,
  } = useIdentity(
    '/teams/{teamId}',
    teamMembershipToUse?.team.id
      ? {
          params: { path: { teamId: teamMembershipToUse.team.id } },
        }
      : null,
  );

  return {
    team,
    loading: teamMembershipsLoading || teamIsLoading,
    error: teamMembershipsError ?? teamError,
  };
}
